import { ButtonLoaderDelayComponent } from './button-loader-delay.component';

export default angular
  .module('sfMobile.components.button-loader-delay', [
    'sfMobile.components.button-loader',
  ])
  .component('sfButtonLoaderDelay', ButtonLoaderDelayComponent).name;
